import { determineIsFaireDirectActiveInLoggedOut } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/determineIsFaireDirectActiveInLoggedOut";
import { SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { pathMatchesRoute } from "@faire/web--source/common/routes/RouteMatcher";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { route as homeRoute } from "@faire/web-api--source/routes/www/root";
export var AppSignUpModalVariant;
(function(AppSignUpModalVariant) {
    AppSignUpModalVariant["DEFAULT"] = "default";
    AppSignUpModalVariant["AUTO"] = "auto";
    AppSignUpModalVariant["AUTO_WITH_IMAGE"] = "auto_with_image";
    AppSignUpModalVariant["PRODUCT"] = "product";
    AppSignUpModalVariant["FACEBOOK"] = "facebook";
    AppSignUpModalVariant["FAIRE_DIRECT"] = "faire_direct";
})(AppSignUpModalVariant || (AppSignUpModalVariant = {}));
export function determineAppSignUpModalVariant(signUpParams, location) {
    if (determineIsFaireDirectActiveInLoggedOut(location)) {
        return AppSignUpModalVariant.FAIRE_DIRECT;
    } else if (signUpParams.signUp === SignUpType.FACEBOOK && isNotUndefined(signUpParams.refP)) {
        return AppSignUpModalVariant.FACEBOOK;
    } else if (signUpParams.signUp === SignUpType.PRODUCT && isNotUndefined(signUpParams.product)) {
        return AppSignUpModalVariant.PRODUCT;
    } else if (signUpParams.signUp === SignUpType.AUTO) {
        var isHomepage = pathMatchesRoute(location, homeRoute);
        return isHomepage ? AppSignUpModalVariant.AUTO : AppSignUpModalVariant.AUTO_WITH_IMAGE;
    } else {
        return AppSignUpModalVariant.DEFAULT;
    }
}
export function isFaireDirectVariant(variant) {
    return variant === AppSignUpModalVariant.FAIRE_DIRECT;
}
export function isAutoSignUpVariant(variant) {
    return variant === AppSignUpModalVariant.AUTO || variant === AppSignUpModalVariant.AUTO_WITH_IMAGE;
}
export function getModalImageryType(variant) {
    if (variant === AppSignUpModalVariant.AUTO_WITH_IMAGE) {
        return "featured-product-image";
    } else if (variant === AppSignUpModalVariant.FACEBOOK || variant === AppSignUpModalVariant.PRODUCT) {
        return "image-from-product-token";
    } else {
        return "no-image";
    }
}
export function getModalImageryFromPageResults(modalImageryType, pageResults, productToken) {
    if (modalImageryType === "featured-product-image") {
        if (pageResults.productTiles) {
            var _pageResults_productTiles_;
            return (_pageResults_productTiles_ = pageResults.productTiles[0]) === null || _pageResults_productTiles_ === void 0 ? void 0 : _pageResults_productTiles_.best_image;
        } else if (pageResults.suppliersPageBrands) {
            var _pageResults_suppliersPageBrands_;
            return (_pageResults_suppliersPageBrands_ = pageResults.suppliersPageBrands[0]) === null || _pageResults_suppliersPageBrands_ === void 0 ? void 0 : _pageResults_suppliersPageBrands_.image;
        } else if (pageResults.pdpProduct) {
            var _pageResults_pdpProduct_visuals;
            return (_pageResults_pdpProduct_visuals = pageResults.pdpProduct.visuals) === null || _pageResults_pdpProduct_visuals === void 0 ? void 0 : _pageResults_pdpProduct_visuals.images[0];
        } else if (pageResults.productBasedCollection) {
            return pageResults.productBasedCollection.image;
        }
    } else if (modalImageryType === "image-from-product-token" && productToken) {
        if (pageResults.productTiles) {
            var _pageResults_productTiles_find, _pageResults_productTiles;
            return (_pageResults_productTiles = pageResults.productTiles) === null || _pageResults_productTiles === void 0 ? void 0 : (_pageResults_productTiles_find = _pageResults_productTiles.find(function(p) {
                var _p_product;
                return (p === null || p === void 0 ? void 0 : (_p_product = p.product) === null || _p_product === void 0 ? void 0 : _p_product.token) === productToken;
            })) === null || _pageResults_productTiles_find === void 0 ? void 0 : _pageResults_productTiles_find.best_image;
        } else if (pageResults.suppliersPageBrands) {
            var brand = pageResults.suppliersPageBrands.find(function(brand) {
                return Object.values(brand.image_tokens_to_product_tokens).indexOf(productToken) >= 0;
            });
            if (brand) {
                return brand.product_images.find(function(image) {
                    return brand.image_tokens_to_product_tokens[image.token || ""] === productToken;
                });
            }
        } else if (pageResults.pdpProduct) {
            if (pageResults.pdpProduct.token === productToken) {
                var _pageResults_pdpProduct_visuals1;
                return (_pageResults_pdpProduct_visuals1 = pageResults.pdpProduct.visuals) === null || _pageResults_pdpProduct_visuals1 === void 0 ? void 0 : _pageResults_pdpProduct_visuals1.images[0];
            }
        }
    }
    return undefined;
}
